import networkAdapter from '../adapters/network';

export const fetchUserConfigFlags = ({ userId }) => {
  let legacyOptions = {
    url: '/api/user-config/v1/external/configs/values-with-reason',
    userId
  };
  
  return networkAdapter({
    legacyOptions
  });
};

export const fetchUserDetails = ({ userId }) => {
  let legacyOptions = {
    url: `/api/user/v2/details?userId=${userId}`,
    userId
  };
  
  return networkAdapter({
    legacyOptions
  });
};

export const fetchSupportInfo = () => {
  let legacyOptions = {
    requiresOldApiDomain: true,
    url: '/static/assets/public-data/support.json'
  };
  
  return networkAdapter({
    legacyOptions
  });
};

export const fetchProductValidationValues = ({ accountCountry='US' }) => {
  const opts = {
    requiresOldApiDomain: true,
    defaultResponse: { useFallbackCountry: true }, // used in case of 404 on accountCountry
    url: `/static/assets/validation/scripting_validations_${accountCountry}.json`
  };
  return networkAdapter({ legacyOptions: opts }).then(response => response.useFallbackCountry
    ? networkAdapter({ legacyOptions: {...opts, url: `/static/assets/validation/scripting_validations_US.json`} })
    : response
  );
};
